/** หมัดไทเก๊ก (lane C4 skeleton): steel + ink, motif yinyang. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const TAIJIFIST_FX: ReturnType<typeof makeHandArt> = makeHandArt('drift-fist', { a: 'steel', b: 'ink', motif: 'yinyang' }, [
  ['tf-push', 'palm', 2],
  ['tf-grasp', 'grab'],
  ['tf-whip', 'claw'],
  ['tf-clouds', 'heal'],
  ['tf-yield', 'buff'],
  ['tf-step', 'palm', 5],
  ['tf-wheel', 'ring', 6],
]);
